// Business facts + EXTERNAL legal links for the app.
// The app does NOT host legal pages — they live canonically on the marketing
// site (editlock.io). The app only links out (Frame.io / standard SaaS pattern).

export const SITE = "https://editlock.io";

export const BUSINESS = {
  name: "Editlock",
  proprietor: "Suvajit Sarkar",
  location: "Bongaon, North 24 Parganas, West Bengal, India",
  site: SITE,
  app: "https://app.editlock.io",
  supportEmail: "support@editlock.io",
  legalEmail: "founder@editlock.io",
} as const;

export const externalLegalLinks = [
  { href: `${SITE}/pricing`, label: "Pricing" },
  { href: `${SITE}/legal/terms`, label: "Terms of Service" },
  { href: `${SITE}/legal/privacy`, label: "Privacy Policy" },
  { href: `${SITE}/legal/refund`, label: "Refunds & Cancellation" },
  { href: `${SITE}/legal/service-delivery`, label: "Service Delivery" },
  { href: `${SITE}/legal/cookies`, label: "Cookie Policy" },
  { href: `${SITE}/contact`, label: "Contact" },
] as const;
